import { useState } from 'react';
import HotelReportFeed from './HotelReportFeed';
import HotelReportSheet from './HotelReportSheet';

/** Self-contained hotel-rollup feed + slide-over, registered as an operation component. */
export default function HotelReportOperation({ soulId }: { soulId: string }) {
  const [openReportId, setOpenReportId] = useState<string | null>(null);
  return (
    <>
      <HotelReportFeed soulId={soulId} onOpenReport={setOpenReportId} />
      <HotelReportSheet
        reportId={openReportId}
        open={!!openReportId}
        onOpenChange={(o) => !o && setOpenReportId(null)}
      />
    </>
  );
}
